<template>
    <div class="modal--warning">
        <div v-b-modal.warning-modal>
            <slot></slot>
        </div>
        <CoreModal
            :id="id"
            :title="title">
            <slot name="message"></slot>

            <div class="mt-3 row">
                <div class="col">
                    <CoreButton
                        type="button"
                        class="btn btn-danger"
                        @click.native="$bvModal.hide(`${id}`)"
                        auto
                        theme="light"
                    >
                        <span> {{ cancelLabel }}</span>
                    </CoreButton>
                </div>
                <div class="col-auto">
                    <CoreButton
                        class="btn btn-success"
                        :loading="loading"
                        :disabled="loading"
                        @click.native="confirm"
                        auto
                        theme="danger"
                    >
                        <slot
                            v-if="$slots.confirm"
                            name="confirm"></slot>
                        <span v-else>{{ confirmLabel }}</span>
                    </CoreButton>
                </div>
            </div>
        </CoreModal>
    </div>
</template>
<script>
export default {
    props: {
        id: {
            default: 'warning-modal'
        },
        loading: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: 'Waarschuwing'
        },
        confirmLabel: {
            type: String,
            default: 'Ja, verwijder'
        },
        cancelLabel: {
            type: String,
            default: 'Nee, annuleer'
        }
    },
    methods: {
        confirm() {
            this.$emit('yes', this.id);
        }
    }
};
</script>
<style lang="scss" scoped>
.modal--warning {
    height: 100%;

    & > div {
        height: 100%;
    }
}
</style>
